import { Box, Text, HStack, Image, Icon } from '@chakra-ui/react';
import { LuLock } from 'react-icons/lu';
import { getCardCompatibilityIcon, getCompatibilityColor } from '@/utils/restaurantUtils';

interface CompatibilityScoreProps {
  /** Raw compatibility score from backend (-1.0 to 1.0) */
  score?: number | null;
  isLocked?: boolean;
  onClick?: () => void;
  /** Use 'light' variant on white/light backgrounds */
  variant?: 'dark' | 'light';
}

export function CompatibilityScore({ score, isLocked, onClick }: CompatibilityScoreProps) {
  // Convert backend score (-1 to 1) to internal rating scale (-100 to 100)
  const internalRating = score != null ? score * 100 : 0;

  // Create a mock restaurant object to reuse existing restaurant utils
  const mockRestaurant = {
    rating: internalRating,
    isBookmarked: false,
    googleRating: null,
  } as any;

  // Reuse existing restaurant utils functions
  const emojiSrc = getCardCompatibilityIcon(mockRestaurant);
  const backgroundColor = getCompatibilityColor(mockRestaurant);

  return (
    <HStack
      spacing={2}
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
      _hover={onClick ? { bg: 'var(--card-divider)' } : undefined}
      transition="all 0.2s"
      bg="var(--card-surface-2)"
      borderRadius="full"
      px={3}
      py={1.5}
    >
      <Box
        bg={isLocked ? 'purple.300' : (backgroundColor || 'var(--color-star-empty)')}
        borderRadius="full"
        p={0.5}
        display="flex"
        alignItems="center"
        justifyContent="center"
        boxSize="24px"
      >
        {isLocked ? (
          <Icon as={LuLock} boxSize="14px" color="white" />
        ) : (
          <Image
            src={emojiSrc}
            alt="PersonalTaste Match"
            boxSize="20px"
          />
        )}
      </Box>
      <Text color="var(--card-text)" fontSize="xs" fontWeight="medium" whiteSpace="nowrap">
        TasteMatch™
      </Text>
    </HStack>
  );
}
